export default __webpack_public_path__ + "static/media/I_sound.b5ea2cd5.mp3";